<template>
  <div>
    <nav-bar ref="form"/>
    <div class="sec-wight-bg py-16 ">
      <div class="container sec-garay-bg border-radius ">
        <div class="row ">
          <h5 class="text-blue col py-0">
            <page-title :titles="'کاتالوگ ها'"/>
          </h5>
        </div>
      </div>
      <!--      <router-link :to="{path:'CatalogueDetail',query:{CatalogueDetailId:item.id}}">-->
      <div v-if="Catalogues !== undefined && Catalogues.length >0" class="container p-md-0" dir="ltr">
        <div class="row">
          <div class="col-12 col-md-3 " v-for="item in Catalogues" :key="item.id">
            <router-link :to="{path:'CatalogueDetail',query:{CatalogueDetailId:item.id}}">
              <div class="bg-Products white--text text-center border-radius-productName py-4">{{ item.title }}</div>
              <div class="bg-product-btn white--text text-center border-radius-product-btn py-4 "><a>مشاهده کاتالوگ</a>
                <div class="col-auto">
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="min-height"></div>
    </div>
    <footer-menu></footer-menu>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import FooterMenu from "@/components/footer";
import PageTitle from "@/components/titles";

export default {
  name: "Catalog-page",
  components: {PageTitle, FooterMenu, NavBar},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-کاتالوگ'
  },
  data: () => ({
    isPageLoaded: false,
    Catalogues: [],
    showResultDialog: false,
    dialogResult: null,
    showLoaderDialog: false,
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },


    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/Catalogues", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.isPageLoaded = true
            let json = JSON.parse(result)

            this.Catalogues = json.filter(x => x.isActive === true)
            this.showLoaderDialog = false;
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>

